import { Route } from '@angular/router';
import { ManageFeaturesComponent } from '@features/activity-types/add-or-remove-features/manage-features/manage-features.component';
import { AssetSelectionScreenComponent } from '@features/shopping/asset/selection-screen/asset-selection-screen.component';
import { FinalizeOrderComponent } from '@features/shopping/finalize-order/finalize-order.component';
import { ReviewComponent } from '@features/shopping/review/review.component';

export const add_or_remove_features_routes: Route[] = [
  {
    path: 'line-selection',
    component: AssetSelectionScreenComponent,
    title: 'Select Line',
    data: { order_type_id: 12 }
  },
  {
    path: 'manage-features',
    component: ManageFeaturesComponent,
    title: 'Manage Features',
    data: { order_type_id: 12 }
  },
  {
    path: 'finalize-order',
    component: FinalizeOrderComponent,
    title: 'Finalize Your Order',
    data: { order_type_id: 12 }
  },
  {
    path: 'review/:id',
    component: ReviewComponent,
    title: 'Review Your Order',
    data: { order_type_id: 12 }
  },
  {
    path: '',
    redirectTo: 'line-selection',
    pathMatch: 'full'
  }
];
